module.exports = __webpack_public_path__ + "static/en_donate_bts@2x-67e4aa823347d797d7670ea57a8624f0.png";